export const ORGANISATION_REQUIRED_ERROR_CODES = new Set([
  'AUTH_ORGANISATION_REQUIRED',
  'NO_ORGANISATION_SELECTED',
]);

export function extractApiErrorCode(error: unknown): string | null {
  return findErrorCode(error, new Set<unknown>(), 0);
}

export function isOrganisationRequiredError(error: unknown): boolean {
  const code = extractApiErrorCode(error);
  return code !== null && ORGANISATION_REQUIRED_ERROR_CODES.has(code);
}

function findErrorCode(
  value: unknown,
  visited: Set<unknown>,
  depth: number,
): string | null {
  if (value === null || value === undefined || depth > 5) {
    return null;
  }

  if (typeof value === 'string') {
    const text = value.trim();
    if (!text) {
      return null;
    }

    try {
      return findErrorCode(JSON.parse(text), visited, depth + 1);
    } catch {
      return null;
    }
  }

  if (typeof value !== 'object' || visited.has(value)) {
    return null;
  }

  visited.add(value);
  const record = value as Record<string, unknown>;
  const code = record['code'];
  if (typeof code === 'string' && code.trim()) {
    return code.trim();
  }

  for (const key of ['error', 'message', 'response', 'body']) {
    const nestedCode = findErrorCode(record[key], visited, depth + 1);
    if (nestedCode) {
      return nestedCode;
    }
  }

  return null;
}
